module.exports = __webpack_public_path__ + "img/dish_meng.7a91ff0a.png";